module.exports = __webpack_public_path__ + "static/media/HTMLLogo.454a400c.png";